// extracted by mini-css-extract-plugin
export var actions = "_t2-4";
export var item = "_t2-1";
export var price = "_t2-3";
export var quantity = "_t2-2";
export var table = "_t2-0";